// Edit this file to add, remove, reorder, or update faculty members for this department.
const facultyData = {
  "hod": {
    "id": "f-poornima-raikar",
    "name": "Dr. Poornima Raikar",
    "designation": "Associate Professor & Head of Department",
    "role": "Associate Professor & Head of Department",
    "qualification": "M.Tech., Ph.D.",
    "qualifications": "M.Tech., Ph.D.",
    "image": "/FacultyCImages/DR_poornima_raikar_AIML.jpeg",
    "email": "hodcseaiml@klsvdit.edu.in, pnr@klsvdit.edu.in",
    "phone": "+91 96115 17345",
    "showPhone": true,
    "experience": "21 years",
    "description": "Dr. Poornima Raikar is the Head of the Department of Computer Science and Engineering (AI & ML) at KLS VDIT. With over 21 years of teaching and research experience, her expertise includes Image Processing and Artificial Intelligence. She is committed to academic excellence, innovation, research, student mentoring, and professional development.",
    "bio": "Dr. Poornima Raikar is the Head of the Department of Computer Science and Engineering (AI & ML) at KLS VDIT. With over 21 years of teaching and research experience, her expertise includes Image Processing and Artificial Intelligence. She is committed to academic excellence, innovation, research, student mentoring, and professional development.",
    "specializations": [
      "Image processing",
      "Artificial Intelligence"
    ],
    "areas": [
      "Image processing",
      "Artificial Intelligence"
    ],
    "courses": [
      "Theory Of Computation",
      "Software Engineering",
      "Problem Solving In C",
      "C++"
    ],
    "publications": 15,
    "projects": 4,
    "linkedin": "https://www.linkedin.com/in/poornima-raikar-1696851b2/",
    "irins": "https://klsvdit.irins.org/profile/249264",
    "recognition": [
      "Best women Karnatak Law Society (KLS) achiever 2015, Information and Communication Technology (ICT) academy Best Single Point of Contact (SPOC) award"
    ]
  },
  "members": [
    {
      "id": "f-ekata-shanbhag",
      "name": "Mrs. Ekata Shanbhag",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/ekata_shanbhag_AIML.jpeg",
      "email": "ess@klsvdit.edu.in",
      "phone": "+91 96208 28376",
      "showPhone": false,
      "experience": "3 years",
      "description": "Mrs. Ekata Shanbhag is an Assistant Professor in the Department of Computer Science and Engineering (AI & ML) at KLS VDIT. Her areas of expertise include Algorithms Design and Analysis, Data Structures, UNIX, Python, and PHP.",
      "bio": "Mrs. Ekata Shanbhag is an Assistant Professor in the Department of Computer Science and Engineering (AI & ML) at KLS VDIT. Her areas of expertise include Algorithms Design and Analysis, Data Structures, UNIX, Python, and PHP.",
      "specializations": [
        "Computer Network",
        "Machine Learning"
      ],
      "areas": [
        "Computer Network",
        "Machine Learning"
      ],
      "courses": [
        "Analysis And Design Of Algorithms (ADA)",
        "Hypertext Preprocessor (PHP)",
        "Database Management System (DMS)",
        "Data Structures"
      ],
      "publications": 4,
      "projects": 0,
      "linkedin": "https://www.linkedin.com/in/ekata-shanbhag-06b895401/",
      "irins": "https://klsvdit.irins.org/profile/441249",
      "recognition": [
        "Faculty Development Programme (FDP)-5",
        "National Programme on Technology Enhanced Learning (NPTEL) -1"
      ]
    },
    {
      "id": "f-amarnath-swami",
      "name": "Mr. Amarnath Swami",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/amarnath_swami_AIML.jpeg",
      "email": "as@klsvdit.edu.in",
      "phone": "+91 63605 42457",
      "showPhone": false,
      "experience": "1 years",
      "description": "Mr. Amarnath Swami is an Assistant Professor in the Department of Computer Science and Engineering (AI & ML) at KLS VDIT. His academic interests include Artificial Intelligence, Machine Learning, Cyber Security, and Data Engineering. He actively mentors students and promotes practical, industry-oriented learning approaches.",
      "bio": "Mr. Amarnath Swami is an Assistant Professor in the Department of Computer Science and Engineering (AI & ML) at KLS VDIT. His academic interests include Artificial Intelligence, Machine Learning, Cyber Security, and Data Engineering. He actively mentors students and promotes practical, industry-oriented learning approaches.",
      "specializations": [
        "Machine Learning",
        "Data Mining and Data Analytics",
        "Cloud Computing and Big data analytics"
      ],
      "areas": [
        "Machine Learning",
        "Data Mining and Data Analytics",
        "Cloud Computing and Big data analytics"
      ],
      "courses": [
        "Machine Learning",
        "Machine Learning -2",
        "Theory Of Computation"
      ],
      "publications": 3,
      "projects": 0,
      "linkedin": "https://www.linkedin.com/in/amarnathswami/",
      "irins": "https://klsvdit.irins.org/profile/710392",
      "recognition": [
        "information to be updated"
      ]
    },
    {
      "id": "f-narasimha-dixit",
      "name": "Mr. Narasimha Dixit",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/narasimha_dixit_AIML.jpeg",
      "email": "nkd@klsvdit.edu.in",
      "phone": "+91 91130 59363",
      "showPhone": false,
      "experience": "3 years",
      "description": "Mr. Narasimha Dixit is an Assistant Professor in the Department of Computer Science & Engineering (Artificial Intelligence & Machine Learning). His areas of interest include Artificial Intelligence, Machine Learning, Natural Language Processing, Deep Learning, and Cyber Security. He has successfully guided four undergraduate projects and actively contributes to research and innovation in emerging technologies. He has published one patent and three research papers in journals. As a member of ACM, he is committed to advancing education and research.",
      "bio": "Mr. Narasimha Dixit is an Assistant Professor in the Department of Computer Science & Engineering (Artificial Intelligence & Machine Learning). His areas of interest include Artificial Intelligence, Machine Learning, Natural Language Processing, Deep Learning, and Cyber Security. He has successfully guided four undergraduate projects and actively contributes to research and innovation in emerging technologies. He has published one patent and three research papers in journals. As a member of ACM, he is committed to advancing education and research.",
      "specializations": [
        "Artificial Intelligence (AI) and Machine Learning (ML)",
        "Natural Language Processing (NLP)",
        "Cyber Security"
      ],
      "areas": [
        "Artificial Intelligence (AI) and Machine Learning (ML)",
        "Natural Language Processing (NLP)",
        "Cyber Security"
      ],
      "courses": [
        "Artificial Intelligence",
        "Deep Learning",
        "Analysis And Design Of Algorithms",
        "Object-Oriented Programming System (OOPS) With Java"
      ],
      "publications": 3,
      "projects": 0,
      "linkedin": "https://www.linkedin.com/in/narasimha-dixit-2b9237267",
      "irins": "https://klsvdit.irins.org/profile/715558",
      "recognition": [
        "Member of Association for Computing Machinery (ACM)"
      ]
    },
    {
      "id": "f-bheerappa-sasanoor",
      "name": "Mr. Bheerappa Sasanoor",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/bheerappa_sasnoor_AIML.jpeg",
      "email": "bys@klsvdit.edu.in",
      "phone": "+91 70196 27017",
      "showPhone": false,
      "experience": "6 years",
      "description": "Mr. Bheerappa Sasanur is an Assistant Professor in the Department of Computer Science and Engineering (AI & ML) at KLS VDIT with six years of teaching experience. He holds an M.Tech in Computer Science and Engineering and is currently pursuing a Ph.D. at VTU.",
      "bio": "Mr. Bheerappa Sasanur is an Assistant Professor in the Department of Computer Science and Engineering (AI & ML) at KLS VDIT with six years of teaching experience. He holds an M.Tech in Computer Science and Engineering and is currently pursuing a Ph.D. at VTU.",
      "specializations": [
        "Cloud",
        "Network Security"
      ],
      "areas": [
        "Cloud",
        "Network Security"
      ],
      "courses": [
        "Computer Network",
        "Data Base Management",
        "Digital Design And Computer Organization"
      ],
      "publications": 0,
      "projects": 0,
      "linkedin": "https://www.linkedin.com/in/bheerappa-sasanoor-6570a364/",
      "irins": "https://klsvdit.irins.org//profile/715520",
      "recognition": [
        "information to be updated"
      ]
    },
    {
      "id": "f-kanchan-khokale",
      "name": "Mrs. Kanchan Khokale",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/kanchan_khokale_AIML.jpeg",
      "email": "kmk@klsvdit.edu.in",
      "phone": "+91 63624 23062",
      "showPhone": false,
      "experience": "0.5 years",
      "description": "Mrs. Kanchan Khokale is an Assistant Professor in the Department of Computer Science and Engineering (AI & ML) at KLS VDIT. Her expertise includes programming languages such as C, Python, and Java. Her research interests focus on Image Processing, and she is dedicated to teaching, mentoring students, and developing problem-solving skills.",
      "bio": "Mrs. Kanchan Khokale is an Assistant Professor in the Department of Computer Science and Engineering (AI & ML) at KLS VDIT. Her expertise includes programming languages such as C, Python, and Java. Her research interests focus on Image Processing, and she is dedicated to teaching, mentoring students, and developing problem-solving skills.",
      "specializations": [
        "Image Processing"
      ],
      "areas": [
        "Image Processing"
      ],
      "courses": [
        "C Programming",
        "Introduction To Artificial Intelligence (AI)",
        "Microcontrollers & Embedded Systems"
      ],
      "publications": 0,
      "projects": 0,
      "linkedin": "https://www.linkedin.com/404/",
      "irins": "https://klsvdit.irins.org/profile/710388",
      "recognition": [
        "information to be updated"
      ]
    },
    {
      "id": "f-ravindra-patil",
      "name": "Mr. Ravindra Patil",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/ravindra_patil_AIML.jpeg",
      "email": "rtp@klsvdit.edu.in",
      "phone": "+91 89719 48465",
      "showPhone": false,
      "experience": "14 years",
      "description": "Mr. Ravindra Patil has been serving in the Department of Computer Science & Engineering since 2012. Currently pursuing a Ph.D., while actively contributing to teaching, academic mentoring, and research in Computer Science and Engineering.",
      "bio": "Mr. Ravindra Patil has been serving in the Department of Computer Science & Engineering since 2012. Currently pursuing a Ph.D., while actively contributing to teaching, academic mentoring, and research in Computer Science and Engineering.",
      "specializations": [
        "Cryptography and Computer Networking"
      ],
      "areas": [
        "Cryptography and Computer Networking"
      ],
      "courses": [
        "Machine Learning",
        "Cryptography",
        "Computer Network",
        "C Programming"
      ],
      "publications": 4,
      "projects": 2,
      "linkedin": "https://www.linkedin.com/in/ravindra-patil-443a38415/",
      "irins": "https://klsvdit.irins.org/profile/249282",
      "recognition": [
        "Received the \"Best Student's Teacher\" Award for the Academic Year 2014-15 in recognition of outstanding contribution to student development and academic excellence",
        "Member of professional bodies including Association for Computing Machinery (ACM)",
        "A member of Indian Society for Technical Education (ISTE)"
      ]
    },
    {
      "id": "f-jyoti-chitti",
      "name": "Mrs. Jyoti Chitti",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/jyoti_chitti_AIML.jpeg",
      "email": "jsc@klsvdit.edu.in",
      "phone": "+91 96328 88053",
      "showPhone": false,
      "experience": "8 years",
      "description": "Mrs. Jyoti Chitti serves as an Assistant Professor in the Department of Computer Science and Engineering (AI & ML) at KLS VDIT, Haliyal. She handles core engineering subjects and focuses on delivering quality education while fostering student learning and development.",
      "bio": "Mrs. Jyoti Chitti serves as an Assistant Professor in the Department of Computer Science and Engineering (AI & ML) at KLS VDIT, Haliyal. She handles core engineering subjects and focuses on delivering quality education while fostering student learning and development.",
      "specializations": [
        "Blockchain technology,",
        "Computer Network and security,",
        "Natural Language Processing,",
        "Cybersecurity"
      ],
      "areas": [
        "Blockchain technology,",
        "Computer Network and security,",
        "Natural Language Processing,",
        "Cybersecurity"
      ],
      "courses": [
        "Design And Analysis Of Algorithm",
        "Programming In C",
        "Big Data Analytics",
        "Operating System"
      ],
      "publications": 0,
      "projects": 0,
      "linkedin": "https://in.linkedin.com/in/jyoti-chitti-417b89276",
      "irins": "https://klsvdit.irins.org/profile/710387",
      "recognition": [
        "Received Excellence award in Edunet Foundation",
        "1 Completed National Programme on Technology Enhanced Learning (NPTEL) courses like (Internet of Things (IoT), Cyber security, AI)",
        "Attended FDPs (Faculty Development Programmes) on Generative Artificial Intelligence (AI), Cybersecurity, Internet of Things (IoT) and Amazon Web Services (AWS)",
        "Presented paper on Internet of Things (IoT) based patient vitals and medicine storage monitoring with blockchain security at International Conference on Computational Intelligence and Communication (ICCIC) 2025",
        "Worked asTechnical master trainer at Edunet Foundation"
      ]
    },
    {
      "id": "f-laxmi-g-hattiholi",
      "name": "Ms. Laxmi G Hattiholi",
      "designation": "Assistant Professor and IQAC coordinator",
      "role": "Assistant Professor and IQAC coordinator",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/laxmi_hattihole_CIVIL.jpeg",
      "email": "iqac@klsvdit.edu.in, lgh@klsvdit.edu.in",
      "phone": "+91 95912 46989",
      "showPhone": false,
      "experience": "14 years",
      "description": "Prof. Laxmi Hattiholi is an Assistant Professor in the Department of Civil Engineering at KLS VDIT, Haliyal, and serves as the IQAC Coordinator. She is pursuing a Ph.D. with a focus on sustainable construction materials. Passionate about continuous learning and innovation, she actively contributes to teaching, institutional development, and social causes, with a commitment to creating a positive impact on society.",
      "bio": "Prof. Laxmi Hattiholi is an Assistant Professor in the Department of Civil Engineering at KLS VDIT, Haliyal, and serves as the IQAC Coordinator. She is pursuing a Ph.D. with a focus on sustainable construction materials. Passionate about continuous learning and innovation, she actively contributes to teaching, institutional development, and social causes, with a commitment to creating a positive impact on society.",
      "specializations": [
        "Concrete Technology",
        "Earthquake Engineering",
        "Sustainable Construction Materials",
        "Soil Structure Interaction"
      ],
      "areas": [
        "Concrete Technology",
        "Earthquake Engineering",
        "Sustainable Construction Materials",
        "Soil Structure Interaction"
      ],
      "courses": [
        "Concrete Technology",
        "Earthquake Engineering",
        "Design Of Reinforced Concrete (RC) Structural Elements",
        "Prestressed Concrete"
      ],
      "publications": 4,
      "projects": 4,
      "linkedin": "https://www.linkedin.com/in/laxmi-hattiholi-924a882a?utm_source=share_via&utm_content=profile&utm_medium=member_android",
      "irins": "https://klsvdit.irins.org/profile/248726",
      "recognition": [
        "Member of Professional bodies Institution of Engineers India (IEI)",
        "A member of Indian Society for Technical Education (ISTE)",
        "Received Research grants from Visvesvaraya Technological University (VTU), Karnataka State Council for Science and Technology (KSCST)",
        "Received Indian Green Building Council (IGBC) accredited Faculty award",
        "Completed All India Council for Technical Education (AICTE) Quality Improvement Programme (QIP) Postgraduate (PG) certification course in Cyber security at Indian Institute of Information Technology (IIIT) dharwad"
      ]
    }
  ]
};

export default facultyData;
